import { memo, useEffect, useRef, useState } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import { GetBrokerPatientsListGroups } from '@/api/endpoints/Broker/BrokerPatient';
import { ColumnsGenerator } from '@/utils/tableUtils';
import UploadPatientSheet from './Components/Popups/UploadPatientSheet';
import ViewMedicalFiles from './Components/Popups/ViewMedicalFiles';
import { AttachmentsUploadedCell, CategoryRequestCell, NameRequestCell } from './Components/RowsData';
import './style.css';
import TableHeader from './Components/TableHeader';
import useNavs from '@/hooks/useNavs';
import { useSelectedTableItems } from '@/components/tableDrawer/reportContent/Hooks/useSelectedTableItems';
import ViewBtn from '@/components/tableDrawer/TableItems/components/tableActions/ViewBtn';
import { TRUE_FALSE_MAP } from '@/data/Constant';

const PatientsListGroups = () => {

    const { BrokerNav } = useNavs();
    const { selectedItems, handleSelected } = useSelectedTableItems()

    const refModal = useRef(null)
    const refViewMedicalFilesModal = useRef(null)
    const [selectedPatientId, setSelectedPatientId] = useState(null)
    
    const viewRequestDetails = (original) =>
        BrokerNav(`clients/patientsListGroups/viewStats/${original?.id}/${original?.orderStatusId}`)

    const columns = [
        ColumnsGenerator.HiddenDropDownCell('isSubmited', 'isSubmited', 'isSubmited', TRUE_FALSE_MAP ,{value: false, label: "No"}),
        ColumnsGenerator.SearchableTextCell('groupName'),
        ColumnsGenerator.HiddenSearchableText('patientName', 'patient'),
        ColumnsGenerator.CustomCell('patient-name',
            (original) => <NameRequestCell original={{ ...original, patientName: `${original.firstName} ${original.lastName}`, requestId: original.patientId }} />),
        ColumnsGenerator.TextCell('gender'),
        ColumnsGenerator.CustomCell('category', (original) => <CategoryRequestCell original={original} />),
        ColumnsGenerator.TextCell('startDate'),
        ColumnsGenerator.TextCell('endDate'),
        ColumnsGenerator.CustomCell('isAttachmentsUploaded', (original) => <AttachmentsUploadedCell original={original} />),
        

        ColumnsGenerator.CustomCell('action', (original) =>
            <>
                <ViewBtn onApply={() => viewRequestDetails(original)}
                    title="view-details"
                    reqAction="canGet"
                    icon="mdi:eye" />

                <BaseBtn onApply={() => viewMedicalFiles(original)}
                    title="view-medical-files"
                    className="medical-files-info"
                    reqAction="canGet"
                    icon={"mdi:file-document-multiple"} />
            </>
        )]



    const viewMedicalFiles = (original) => {
        setSelectedPatientId(original?.patientId)
        console.log(original?.patientId)
        refViewMedicalFilesModal?.current?.click()
    }



    return (
        <>
            <TableHeader refModal={refModal} selectedItems={selectedItems} />

            <UploadPatientSheet refModal={refModal} />

            <ViewMedicalFiles refModal={refViewMedicalFilesModal} setSelectedPatientId={setSelectedPatientId} patientId={selectedPatientId} />

            <ReportContent needCheckbox handleSelected={handleSelected} tableAPI={GetBrokerPatientsListGroups} columns={columns} isSubmitted={true} stickyActions>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(PatientsListGroups);